export default (query = null) => ({
  type: 'SET_SEARCH_QUERY',
  payload: {
    data: {
      info: query,
    },
  },
})
